export default "__VITE_ASSET__3a5121c5__"